const pluginsToMutate = new Set( [
  'userPosition.action.centerOnItems',
  'userPosition.action.centerOnUser',
  'molten.dataViewers.map.EditSettingsAction',
  'molten.mapDataViewer.ZoomIn',
  'molten.mapDataViewer.ZoomOut',
  'molten.mapDataViewer.Satellite',
  'molten.mapDataViewer.TimeRange',
  'blueprint.product.shape.CreatePointer'
] )

export default function MapSettingsActionMutator( type, plg, molten ) {
  if ( pluginsToMutate.has( plg.id ) ) {
    return {
      ...plg,
      handles : ( context ) => {
        const { client } = context
        if ( client !== 'GoogleMapsDataViewer' ) {
          return false
        }

        return true
      }
    }
  }

  return plg
}
